import { render, staticRenderFns } from "./account.vue?vue&type=template&id=28776d8f&scoped=true&lang=pug&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28776d8f",
  null
  
)

export default component.exports